<template>
  	<div>
    	<v-stepper color="primary" v-model="e1" vertical non-linear>
			<v-stepper-step
				color="primary"
				editable
				:complete="complete_step_1"
				step="1"
				:edit-icon="'check'"
			>
				{{getStateWithParam("parking_plate")}}<template v-if=" plate.length "> - {{plate}}</template>
				<div v-if="plate.length < 7" class="red--text step-error-mesg">{{getStateWithParam("parking_plate_to_short")}}</div>
			</v-stepper-step>
			<v-stepper-content step="1">
				<div class="pay-with-sms-input">
					<input
						type="text"
						v-model="plate"
						class="targa-input"
						maxlength="15"
						placeholder="__ • ___ ____________"
						@input="checkPlateComplete"
					/>
				</div>
			</v-stepper-content>
			<v-stepper-step
				color="primary"
				editable
				:complete="complete_step_2"
				step="2"
				:edit-icon="'check'"
			>
				{{getStateWithParam("parking_place")}}<template v-if="zona"> - {{zona_object.emri}} - {{zona_object.cmimi}} Lek</template>
			</v-stepper-step>
			<v-stepper-content color="primary" step="2">
				<v-card-text>
					<v-radio-group v-model="zona" @change="getZonaNameForPaying">
						<template v-for=" zitem in data_temp ">
							<v-radio :key=" 'zitem-' + zitem.kodi " :label="zitem.emri + ' - ' + zitem.cmimi + ' Lek'" :value="zitem.kodi"></v-radio>
						</template>
					</v-radio-group>
				</v-card-text>
			</v-stepper-content>

			<v-stepper-step
				editable
				color="primary"
				:complete="complete_step_3"
				step="3"
				:edit-icon="'check'"
			>{{getStateWithParam("time_duration")}} - {{radio_hour_value}} {{getStateWithParam("parking_time_label")}}</v-stepper-step>
			<v-stepper-content color="primary" step="3">
				<v-card-text>
					<v-radio-group v-model="radio_hour_value">
						<v-radio :label="getStateWithParam('1_hour')" value="1"></v-radio>
						<v-radio :label="getStateWithParam('2_hour')" value="2"></v-radio>
						<v-radio :label="getStateWithParam('3_hour')" value="3"></v-radio>
					</v-radio-group>
				</v-card-text>
			</v-stepper-content>
			<v-stepper-step @click="sendSms()" color="primary" class="last-step-btn" step="4">
				<!-- flat -->
				<v-btn tile large full color="primary ma-0" class="dergo-sms-btn">
					{{getStateWithParam("send_sms")}}
					<v-icon>textsms</v-icon>
				</v-btn>
			</v-stepper-step>
    	</v-stepper>
  	</div>
</template>

<script>
//import TableCard from "./TableCard.vue";
import parking from "@/config/api/api_events/parking.js";

export default {
  	name: "PayWithSmsCard",
	components: {
		//"table-card": TableCard
	},
	data() {
		return {
			e1: 0,
			hasSaved: false,
			model: null,
			data_temp: [],
			from_where: 2,
			info_header: [
				{
					text: this.getStateWithParam("street"),
					align: "left",
					sortable: false,
					value: "emri"
				}
			],
			radio_hour_value: "1",
			complete_step_1: false,
			complete_step_2: false,
			complete_step_3: true,
			plate: "",
			zona: null
		};
	},
	computed: {
		zona_object() {
			let zonaobj = null
			if (this.zona) {
				zonaobj = this.data_temp.find( zitem => zitem.kodi == this.zona)
			}
			return zonaobj
		}
	},
  	mounted() {
		this.getParkingPlaces();
		this.getPlateFromStorage();
		this.complete_step_1 = this.onPlateComplete();
	},
	watch: {
		plate(newPlate) {
			localStorage.plate = newPlate;
		}
	},
	methods: {
		getPlateFromStorage() {
			if (localStorage.plate) {
				this.plate = localStorage.plate;
			}
		},
		getZonaNameForPaying() {
			this.complete_step_2 = this.zona !== null;
		},
		getParkingPlaces() {
			// Not getting data because of the baq url
			// change this after
			parking
			.getParkingStreets()
			.then(response => {
				this.data_temp = response.sms_rruget.map(el => {
					return {
						emri: el.sms_rruga_emertimi,
						kodi: el.sms_rruga_kodi,
						cmimi: el.sms_cmimi
					};
				});
			})
			.catch(error => {
				console.log("There was an error:", error);
			});
		},
		sendSms() {
			if (this.onPlateComplete() && this.complete_step_2) {
				let smsstring = "sms:50500?body=" + this.plate + " " + this.zona + " " + this.radio_hour_value
				smsstring.toUpperCase()
				window.open( smsstring, "_system" );
			}
		},
		customFilter(item, queryText, itemText) {
			const textOne = item.name.toLowerCase();
			const searchText = queryText.toLowerCase();

			return textOne.indexOf(searchText) > -1;
		},
		save() {
			this.isEditing = !this.isEditing;
			this.hasSaved = true;
		},
		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		},
		checkPlateComplete(){
			this.complete_step_1 = this.onPlateComplete()
		},
		onPlateComplete() {
			let plate = this.plate;
			plate.replace(/ /g, "");
			plate.replace(/[^a-z0-9]/gi, "").toUpperCase();
			if (plate.length >= 7) {
				if (localStorage.plate) {
					plate = localStorage.plate;
					return true;
				}
			}
			return false;
		}
  	}
};
</script>

<style scoped lang="scss">
.pay-with-sms-input {
	height: 80px;
	background-image: url("../../assets/svg/targa.svg");
	background-size: 100% 80px;
	padding: 0 40px;
	.targa-input {
		width: 100%;
		height: 100%;
		font-size: 28px;
		font-weight: 600;
		letter-spacing: 2px;
		color: black;
		text-transform: uppercase;
		font-family: "Roboto", sans-serif;
		text-align: center;
		&:focus {
			outline: none !important;
		}
		&::placeholder {
			color: rgb(228, 228, 228);
		}
	}
}

.v-stepper--vertical {
	box-shadow: none;
	padding-bottom: 0;
	.v-stepper__step {
		padding: 15px;
	}
	.v-stepper__content {
		margin-left: 24px;
		border-left: 4px dotted rgba(57, 64, 243, 0.22) !important;
		margin-top: 0px;
		margin-bottom: 0px;
		.v-card__text {
			padding: 0;
			.v-input {
				margin: 0;
				padding: 0px;
				.v-input__control {
					.v-input__slot {
						margin-bottom: 0 !important;
					}
				}
			}
		}
	}
}

.v-messages {
  	display: none !important;
}

.v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
  	margin-bottom: 0px !important;
}

.dergo-sms-btn {
	position: absolute !important;
	bottom: 0;
	width: 100%;
	left: 0;
	right: 0;
	margin: 0;
	height: 45px;
	color: white !important;
	font-weight: 700;
	.v-btn {
		color: white !important;
	}
	.v-icon {
		padding-left: 8px;
	}
	&:focus {
		position: absolute;
	}
}

.v-label {
  	font-size: 14px !important;
}

.v-autocomplete {
  	font-size: 14px !important;
}

.v-input--selection-controls {
  	margin-bottom: 55px !important;
}

.v-stepper__label {
	text-transform: uppercase;
	font-weight: 500;
}

.last-step-btn {
	height: 56px;
	.v-stepper__step__step {
		display: none !important;
	}
}
thead {
  	display: none;
}
.step-error-mesg{
	font-size: 10px;
}
</style>
